import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

import auth from './modules/auth'
import organisation from './modules/organisation'
// import user from './modules/user'

Vue.use(Vuex);

var ls = new SecureLS({
  encodingType: "aes",
  isCompression: true,
  encryptionSecret: "LuIEpuIYx__uiQlMDh1y_mlzDSm9gB4G9ayUtoRS0BhzWmf7IgpwEEbYV3vciLpw"
});


export default new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    organisation,
    // user,
  },
  plugins: [
    createPersistedState({
      key: 'pentester',
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});